import React from 'react';
import './LisansKosullari.css';
import { FaEye, FaDownload } from 'react-icons/fa';

const LisansKosullari = () => {
  const pdfUrl = "/lisans-kosullari.pdf";

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'lisans-kosullari.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="lisans-container">
      <div className="lisans-header">
        <h1>Hakkında Ve Lisans Koşullari</h1>
        <p>Hazırladığımız detaylı kılavuzu inceleyebilir veya cihazınıza indirebilirsiniz.</p>
      </div>

      <div className="action-card">
        <h2 className="action-title">Hakkında ve Lisans Koşulları Erişim Seçenekleri</h2>
        <div className="button-group">
          <button 
            onClick={() => window.open(pdfUrl, '_blank')}
            className="pdf-btn btn-view"
          >
            <FaEye className="icon" />
            PDF'yi Görüntüle
          </button>
          
          <button 
            onClick={handleDownload}
            className="pdf-btn btn-download"
          >
            <FaDownload className="icon" />
            PDF'yi İndir
          </button>
        </div>
      </div>

      <div className="pdf-viewer-container">
        <iframe 
          src={pdfUrl} 
          className="pdf-viewer"
          title="Hakkında ve Lisans Koşulları"
        />
      </div>
    </div>
  );
};

export default LisansKosullari;